import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getBranchBindingCustInfoList, bindingBranchCustRelation } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'BindCustomerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, null],
      default: null
    },
    isSee: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const keyWord = ref('');
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        keyWord.value = '';
        table.value.commitProxy('reload');
      }
    }, {
      flush: 'post'
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      bindingBranchCustRelation({}, {
        params: {
          branchId: props.data.branchId,
          custIdList: selectRows.map(i => i.erpCustId).join(','),
          bindingFlag: 1,
          __repeat: true,
          __warn: true
        }
      }).then(data => {
        if (data.success) {
          ElMessage.success('操作成功!');
          visible.value = false;
          emit('success');
        }
      });
    }

    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        field: '全选',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'erpCustId',
        title: '客户ID',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custName',
        title: '客户名称',
        width: '150px',
        showOverflow: true
      }, {
        field: 'custType',
        title: '客户类型',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custAddress',
        title: '详细地址',
        width: '300px',
        showOverflow: true
      }, {
        field: 'custArea',
        title: '所在区域',
        width: '200px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '联系人',
        width: '150px',
        showOverflow: true
      }, {
        field: 'linkPhone',
        title: '联系电话',
        width: '150px',
        showOverflow: true
      }],
      checkboxConfig: {
        checkMethod() {
          return !props.isSee;
        }

      },
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getBranchBindingCustInfoList({
              page: page.currentPage,
              pageSize: page.pageSize,
              branchId: props.data.branchId,
              custName: keyWord.value,
              bindingFlag: !props.isSee ? 0 : 1
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.custInfoList
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.isSee ? '查看客户' : '绑定客户',
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "1000px"
      }, {
        footer: _withCtx(() => [!__props.isSee ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })], 64)) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "客户名称"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: keyWord.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyWord.value = $event),
                  modelModifiers: {
                    trim: true
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 2
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  icon: "Search",
                  onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
                }, {
                  default: _withCtx(() => [_hoisted_1]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};